<template>
  <v-app>
    <ClientNavBar/>
    <v-main>
      <v-container>        
        <router-view />
      </v-container>
    </v-main> 
  </v-app>

</template>

<script>
import ClientNavBar from '@/components/client/ClientNavBar.vue'

export default {
  name: 'ClientLayout',
  data() {
    return {      
    }
  },  
  components: {
    ClientNavBar
  },
  // computed: {
  //   hideMenu() {
  //     // Hide menu if route is /evaluation or starts with /evaluation/
  //     return this.$route.name === 'EvaluationView' || this.$route.path.startsWith('/evaluation');
  //   }
  // }
}
</script>

<style>
.v-app {
  min-height: 100vh;
}
</style>